import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import Heading from 'shopper/components/Heading';
import Text from 'shopper/components/Text';

import toPageDescription from 'lib/htmlParsers/parsePageDescriptionHtml';

const TopicPageDescription = ({
  headingProps = {},
  paragraphProps = {},
  paragraphPropsClassName,
  paragraphs = [],
  title = null,
}) => (
  <>
    {title && (
      <Heading as="h2" className="mb-4 mt-6" size="size3" {...headingProps}>
        {title}
      </Heading>
    )}
    {paragraphs.map((paragraph, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <Text
        key={index}
        className={twMerge('mb-6', paragraphPropsClassName)}
        {...paragraphProps}
      >
        {toPageDescription(paragraph)}
      </Text>
    ))}
  </>
);

TopicPageDescription.propTypes = {
  title: PropTypes.string,
  paragraphs: PropTypes.arrayOf(PropTypes.string),
  headingProps: PropTypes.shape(),
  paragraphProps: PropTypes.shape(),
};

export default TopicPageDescription;
